import { Bookmark, GroupBookmark } from '@otp/icons';
import React from 'react';

type BookmarkActionProps = {
  id: string;
  organizationId?: string | null;
};

export const BookmarkAction = ({ organizationId }: BookmarkActionProps) => {
  if (organizationId) {
    return <GroupBookmark />;
  }

  return (
    <>
      <Bookmark />
    </>
  );
};
